export const graphQLHttpUrl = process.env.REACT_APP_GRAPHQL_URL;
export const graphQLWebSocketUrl =
  process.env.REACT_APP_NOTIFICATIONS_WEBSOCKET_URL;
